
        import i18n from './js/i18n.js';
        // Initialize i18n system on page load
        (async () => {
            await i18n.init();
        })();
    